module.exports = __webpack_public_path__ + "static/img/wealth_level_91.2ee09d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_91.png
// module id = 3B7w
// module chunks = 0